/**
 * Rename function
 *
 * @param {function} func - function to be renamed
 * @param {string} name - function's new name
 *
 * @returns {function}
 */
export default function renameFunc(func, name) {
	/* eslint-disable no-param-reassign */
	Object.defineProperty(func, 'name', { writable: true });
	func.name = name;
	Object.defineProperty(func, 'name', { writable: false });
	return func;
	/* eslint-enable no-param-reassign */
}
